import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';

@Injectable()
export class scheduleService {

  user:any;
  constructor(private http: HttpClient,private _global:Globals) {
    
  }
  readonly rootUrl = this._global.siteUrl;

  addschedule(scheduleObj){
    var date;
    var Fromdate;
    var Todate;
  var starttimee=scheduleObj.starttime.hour+':'+scheduleObj.starttime.minute+':'+scheduleObj.starttime.second;
  var endtimee=scheduleObj.endtime.hour+':'+scheduleObj.endtime.minute+':'+scheduleObj.endtime.second;
  if(scheduleObj.ScheduleType=='Monthly'){
  date=scheduleObj.date.year+'-'+scheduleObj.date.month+'-'+scheduleObj.date.day;
  }
  else if(scheduleObj.ScheduleType=='Range'){
    Fromdate=scheduleObj.Fromdate.year+'-'+scheduleObj.Fromdate.month+'-'+scheduleObj.Fromdate.day;
    Todate=scheduleObj.Todate.year+'-'+scheduleObj.Todate.month+'-'+scheduleObj.Todate.day;

  }
  
  var venueId=scheduleObj.Venue.toString();
  //var batchId=scheduleObj.Batch.toString();
    const body = {
      ScheduleType:scheduleObj.ScheduleType,
      Fromdate:Fromdate,
      Todate:Todate,
      date:date,
      starttime:starttimee,
      endtime:endtimee,
      subjectId:scheduleObj.Subject,
      teacherId:scheduleObj.Teacher,
      centerId:scheduleObj.Center,
      venueId:venueId,
      sessionId:0,
      courseId:scheduleObj.Course,
      batchtypeId:scheduleObj.BatchType,
      examId:scheduleObj.Exam,
      streamId:scheduleObj.stream,
      batchId:scheduleObj.Batch,
      status:scheduleObj.Status,
      createdBy:scheduleObj.userid
    }
   
    return this.http.post(this.rootUrl + 'schedule/addschedule', body);
  
  }

  editschedulee(scheduleObj,scheduleId){
  var starttimee=scheduleObj.starttime.hour+':'+scheduleObj.starttime.minute+':'+scheduleObj.starttime.second;
  var endtimee=scheduleObj.endtime.hour+':'+scheduleObj.endtime.minute+':'+scheduleObj.endtime.second;

  var date=scheduleObj.date.year+'-'+scheduleObj.date.month+'-'+scheduleObj.date.day;
  var venueId=scheduleObj.Venue.toString();
  //var batchId=scheduleObj.Batch.toString();
    const body = {
      date:date,
      starttime:starttimee,
      endtime:endtimee,
      subjectId:scheduleObj.Subject,
      teacherId:scheduleObj.Teacher,
      centerId:scheduleObj.Center,
      venueId:venueId,
      sessionId:0,
      courseId:scheduleObj.Course,
      batchtypeId:scheduleObj.BatchType,
      examId:scheduleObj.Exam,
      streamId:scheduleObj.stream,
      batchId:scheduleObj.Batch,
      status:scheduleObj.Status,
      createdBy:scheduleObj.userid,
      id:scheduleId,
    }
    return this.http.post(this.rootUrl + 'schedule/editschedule', body);
  }

  schedulelist(start,end,searcharray){
    //return this.http.get(this.rootUrl+"schedule/schedulelist?start="+start+"&end="+end+'&search='+searcharray);
    const body = {
      start: start,
      end:end,
      searcharray:searcharray
    }
    return this.http.post(this.rootUrl + 'schedule/schedulelist', body);
  }

  schedulelistByUser(obj){
    var data="res=1";
    data +=this.makegetStr(obj);
    console.log(data);
  //  start="+start+"&end="+end+'&search='+searchtxt
  //var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded',"no-auth":"false"});
  return this.http.post(this.rootUrl+'schedule/schedulelistByUser', obj);
  
  }

  editschedule(scheduleId){
    return this.http.get(this.rootUrl+"schedule/getschedule?cid="+btoa(scheduleId));
  }

  delschedule(scheduleId){
    const body = {
     id: scheduleId,
     isDeleted:1
   }
   return this.http.post(this.rootUrl + 'schedule/delschedule', body);
  }

  makegetStr(obj){
    var str="";
    if(obj){
      for(var i in obj){
          str +="&"+i+"="+encodeURI(obj[i]);
      }

    }

  return str;
  }

  addstreammpg(obj){
    return this.http.post(this.rootUrl+'schedule/addstreammpg', obj);
  }

  streamlist(start,end,search){
    const body = {
      start: start,
      end:end,
      search:search
    }
    return this.http.post(this.rootUrl+'schedule/streammpglist', body);
  }
  getstreammpg(Id){
    const body = {
      id:btoa(Id),
    }
    return this.http.post(this.rootUrl+"schedule/getstreammpg",body);
  }

  editstreammpg(Obj,Id){
    const body = {
      streamId:Obj.stream,
      subjectId:Obj.Subject,
      status:Obj.Status,
      createdBy:Obj.userid,
      id:Id
    }
   
    return this.http.post(this.rootUrl + 'schedule/editstreammpg', body);

  }

  delstremm(Id){
    const body = {
     id: Id,
     isDeleted:1
   }
   return this.http.post(this.rootUrl + 'schedule/delstremm', body);
  }


}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/schedule.service.ts